import type { RawReport, Report } from '../types';
import type { Account, Advertiser } from '@/features/users';

export function normalizeReport(report: RawReport): Report {
  const { meta, ...other } = report;
  const advertisers = (meta.advertisers ?? meta.accounts ?? []).map(
    (advertiser: Advertiser | Account) => ({
      ...advertiser,
      name: advertiser.name ?? '',
    })
  );

  return {
    ...other,
    meta: {
      advertisers,
    },
  };
}
